export default __webpack_public_path__ + "static/media/11.3ac24698.png";